module.exports = __webpack_public_path__ + "static/media/right-arrow-dark.b87fa25d.svg";